import Image from 'next/image'
import React, { useContext } from 'react'
import { BASE_URL } from '../../utils/FetchData';
import { isMobileContext } from '../../contexts/isMobileContext';
import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from 'next-i18next';

const TestimonialsCard = ({ cardData, index, isActive, length, slideNumber }) => {
    const { isMobile } = useContext(isMobileContext);
    const { t } = useTranslation("common")
    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                delayChildren: .2,
            }
        }
    }
    const item = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: { duration: .5 }
        }
    }
    const image = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: { duration: .5 }
        }
    }
    return (
        <AnimatePresence reset key={cardData.id}>
            {isActive && <motion.div className='testimonials-card'
                variants={container}
                initial="hidden"
                whileInView="show"
                exit={"hidden"}
                viewport={{ once: true }}
                key={cardData.id}
            >
                <motion.div variants={image} className='img-section'>
                    <div className="img-container">
                        {cardData?.Personal_Img_Desktop?.data?.attributes?.url && <Image
                            src={`${BASE_URL}${isMobile ? cardData?.Personal_Img_Mobile?.data?.attributes?.url : cardData?.Personal_Img_Desktop?.data?.attributes?.url}`}
                            alt={isMobile ? cardData?.Personal_Img_Mobile?.data?.attributes?.name : cardData?.Personal_Img_Desktop?.data?.attributes?.name}
                            objectFit="cover"
                            layout='fill'
                        />}
                    </div>
                </motion.div>
                <motion.div className='card-data'>
                    <div className="slider-number bold">
                        {`${slideNumber} ${t('360_works.of')} 0${length}`}
                    </div>
                    <motion.div variants={item} className='title light'>{cardData?.Title}</motion.div>
                    <motion.div variants={item} className='description'>{cardData?.Description}</motion.div>
                    <motion.div variants={item} className='name bold'>{cardData?.Name}</motion.div>
                    <motion.div variants={item} className='position'>{cardData?.Position}</motion.div>
                </motion.div>
            </motion.div>}
        </AnimatePresence>
    )
}

export default TestimonialsCard
